/* global window, document */

(function (window, document) {
    var root = document.getElementById('radar-mappa-competitiva-root');
    if (!root) return;

    function qs(sel, el) { return (el || document).querySelector(sel); }
    function setStatus(msg) { var el = qs('[data-radar-status]', root); if (el) el.textContent = msg || ''; }
    function pad2(n) { return (n < 10 ? '0' : '') + n; }
    function toISODate(d) { return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate()); }

    function stripTrailingZerosToPrefix(code) {
        var s = String(code || '').replace(/\D/g, '');
        if (!s) return '';
        if (s.length > 8) s = s.slice(0, 8);
        s = s.replace(/0+$/g, '');
        return s || String(code || '').replace(/\D/g, '').slice(0, 8);
    }

    function readFilters() {
        var form = qs('[data-radar-filters]', root);
        if (!form) return {};
        var fd = new FormData(form);
        var out = {};
        ['cpv', 'date_from', 'date_to'].forEach(function (k) {
            var v = fd.get(k);
            if (v != null && String(v).trim() !== '') out[k] = String(v).trim();
        });
        return out;
    }

    function initDefaultYearDates() {
        var form = qs('[data-radar-filters]', root);
        if (!form) return;
        var from = qs('input[name="date_from"]', form);
        var to = qs('input[name="date_to"]', form);
        if (from && to && !String(from.value || '').trim() && !String(to.value || '').trim()) {
            var now = new Date();
            var jan1 = new Date(now.getFullYear(), 0, 1);
            from.value = toISODate(jan1);
            to.value = toISODate(now);
        }
    }

    function initCpvAutocomplete() {
        var form = qs('[data-radar-filters]', root);
        if (!form) return;
        var input = form.querySelector('input[name="cpv_query"]');
        var hidden = form.querySelector('input[name="cpv"]');
        var clearBtn = form.querySelector('[data-cpv-clear]');
        var list = document.getElementById('radar-mappa-competitiva-cpv-list');
        if (!input || !hidden || !list) return;
        var memberUuid = (root.getAttribute('data-member-uuid') || '').trim();

        function render(items) {
            while (list.firstChild) list.removeChild(list.firstChild);
            (items || []).forEach(function (it) {
                var opt = document.createElement('option');
                var code = it.code_main || '';
                var label = it.label_it || '';
                opt.value = code + (label ? ' — ' + label : '');
                list.appendChild(opt);
            });
        }

        var lastFetch = 0;
        var pending;
        var saveTimer;
        function persistCpv(prefix) {
            if (!memberUuid) return;
            if (saveTimer) window.clearTimeout(saveTimer);
            saveTimer = window.setTimeout(function () {
                fetch(apiBase + '/telegram/cpv', {
                    method: 'POST',
                    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
                    body: JSON.stringify({ member_uuid: memberUuid, cpv_prefix: prefix || null })
                }).catch(function () {});
            }, 220);
        }

        function syncClearBtn() {
            if (!clearBtn) return;
            clearBtn.disabled = !String(hidden.value || '').trim();
        }

        var lastResolvedPrefix = '';
        function resolveAndShowLabel(prefix) {
            var p = String(prefix || '').trim();
            if (!p || p === lastResolvedPrefix) return Promise.resolve();
            lastResolvedPrefix = p;
            var url = apiBase + '/radar/hub/cpv-suggest?q=' + encodeURIComponent(p) + '&limit=1';
            return fetch(url, { headers: { Accept: 'application/json' } })
                .then(function (r) { return r.ok ? r.json() : {}; })
                .then(function (data) {
                    var it = data && data.items && data.items[0];
                    if (!it) return;
                    var code = String(it.code_main || '').trim();
                    var label = String(it.label_it || '').trim();
                    if (!code) return;
                    input.value = code + (label ? ' — ' + label : '');
                })
                .catch(function () {});
        }
        function fetchSuggest(q) {
            var now = Date.now();
            lastFetch = now;
            var url = apiBase + '/radar/hub/cpv-suggest?q=' + encodeURIComponent(q) + '&limit=15';
            return fetch(url, { headers: { Accept: 'application/json' } })
                .then(function (r) { if (!r.ok) throw r; return r.json(); })
                .then(function (data) { if (lastFetch !== now) return; render((data && data.items) || []); })
                .catch(function () {});
        }

        input.addEventListener('input', function () {
            var q = String(input.value || '').trim();
            if (pending) window.clearTimeout(pending);
            if (q.length < 2 && !/\d/.test(q)) return;
            pending = window.setTimeout(function () { fetchSuggest(q); }, 180);
        });

        function syncHidden() {
            var raw = String(input.value || '').trim();
            var digits = raw.replace(/\D/g, '');
            hidden.value = digits ? stripTrailingZerosToPrefix(digits) : '';
            persistCpv(hidden.value);
            syncClearBtn();
        }
        input.addEventListener('input', syncHidden);
        input.addEventListener('blur', function () {
            syncHidden();
            if (!String(hidden.value || '').trim()) {
                lastResolvedPrefix = '';
                return;
            }
            resolveAndShowLabel(hidden.value);
        });

        if (clearBtn) {
            clearBtn.addEventListener('click', function () {
                input.value = '';
                hidden.value = '';
                lastResolvedPrefix = '';
                persistCpv('');
                syncClearBtn();
            });
        }

        syncClearBtn();

        if (memberUuid) {
            fetch(apiBase + '/telegram/settings?member=' + encodeURIComponent(memberUuid), { headers: { Accept: 'application/json' } })
                .then(function (r) { return r.ok ? r.json() : {}; })
                .then(function (data) {
                    var p = String((data && data.cpv_prefix) || '').trim();
                    if (!p) return;
                    hidden.value = p;
                    syncClearBtn();
                    resolveAndShowLabel(p);
                })
                .catch(function () {});
        }
    }

    var apiBase = (root.getAttribute('data-api-base') || '').replace(/\/+$/, '');
    var client = new window.AppaltiMap.ApiGatewayClient({
        baseUrl: apiBase,
        tokenStore: new window.AppaltiMap.TokenStore('appaltimap_auth')
    });

    function getJson(url) {
        var token = client.tokenStore.getToken() || '';
        var headers = { Accept: 'application/json' };
        if (token) headers.Authorization = 'Bearer ' + token;
        return fetch(url, { headers: headers }).then(function (r) { if (!r.ok) throw r; return r.json(); });
    }

    function load() {
        var f = readFilters();
        var outEl = qs('[data-radar-json]', root);
        setStatus('Caricamento…');
        return getJson(apiBase + '/radar/geo/city-layer?' + new URLSearchParams(f).toString())
            .then(function (data) {
                if (outEl) outEl.textContent = JSON.stringify(data, null, 2);
                setStatus('');
            })
            .catch(function () {
                if (outEl) outEl.textContent = '—';
                setStatus('Impossibile caricare.');
            });
    }

    var form = qs('[data-radar-filters]', root);
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); load(); });
    initDefaultYearDates();
    initCpvAutocomplete();
})(window, document);

